import { type TableColumnConfig, TextEllipsisCellComponent } from '@pct-ng/feature-table-material';

export function createUpdatedByNameColumn<T>(
  i18nPrefix: string,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: 'updatedByName',
    field: 'updatedByName' as keyof T,
    label: `${i18nPrefix}UPDATED_BY_NAME`,
    cellContent: TextEllipsisCellComponent,
    sortable,
  };
}
